import './OPAY.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import paymentMethod from 'extensions/payment-method';
import ConfirmAction from 'extensions/confirm-action';
import {SummaryEvents} from 'extensions/checkout-pages';

export default class OPAY extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		new ConfirmAction('.js-confirm-exit', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: this.pageContext.Basket_Url
		});

		new SummaryEvents();

		this.initPromoCodeEvents();
		this.creditCardDetection();

		/**
		 * Added functionality to help style the default Miva output payment
		 * fields.
		 */

		const cvvElem = document.querySelector('[data-id="cvv"]');
		const cvvInput = cvvElem
			? cvvElem.querySelector('input')
			: null;

		if (cvvInput) {
			cvvInput.setAttribute('type', 'tel');
		}

	}

	creditCardDetection () {

		/**
		 * Credit Card Detection
		 */

		const detectCard = document.getElementsByClassName('js-detect-card');
		const paymentMethodDisplays = document.getElementsByClassName('js-payment-method-display');
		const paymentMethods = document.getElementsByClassName('js-payment-method');

		const detectPaymentMethod = function (input) {
			if (isNaN(input.value)) {
				input.classList.add('has-error');
			}

			paymentMethod(input, function (paymentDetected) {
				if (!paymentDetected) {
					return;
				}

				input.classList.remove('has-error');

				if (paymentMethodDisplays.length) {
					for (const paymentMethodDisplay of paymentMethodDisplays) {
						paymentMethodDisplay.innerText = paymentDetected.display;
					}
				}

				if (paymentMethods.length) {
					for (const payMethod of paymentMethods) {
						payMethod.value = window.supportedPaymentMethods.findPaymentMethod(paymentDetected.name);
					}
				}
			});
		};

		if (detectCard.length) {
			for (const input of detectCard) {
				input.setAttribute('type', 'tel');
				input.addEventListener('input', () => detectPaymentMethod(input), false);
				input.addEventListener('paste', () => detectPaymentMethod(input), false);
			}
		}
	}

	async initPromoCodeEvents () {

		const promoCodeContainers = document.getElementsByClassName('g-checkout__order-summary-promo-form');

		if (!promoCodeContainers.length) {
			return;
		}

		const {PromoCodeEvents} = await import('extensions/checkout-pages');

		for (const promoCodeContainer of promoCodeContainers) {
			const input = promoCodeContainer.querySelector('input[type=text]');
			const submitElement = promoCodeContainer.querySelector('[type=submit]');

			if (input && submitElement) {
				new PromoCodeEvents(input, submitElement);
			}
		}

	}

}
